import { render } from "./DepartmentGroup.vue?vue&type=template&id=878e78de"
import script from "./DepartmentGroup.vue?vue&type=script&lang=js"
export * from "./DepartmentGroup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__